import { createAction, props } from '@ngrx/store';
import { ApplicationConfiguration } from '../../../camms-risk/models/application-configuration/application-configuration';

export const setApplicationConfigurations = createAction(
    '[Application] Set App Configuration',
    props<{ appConfig: ApplicationConfiguration }>(),
);
